/**
 * PushNotification.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import './PushNotification.css';

function formatSubmission(submission) {
  return new Date(submission).toLocaleDateString('de-DE', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

function Submission(_ref) {
  var time = _ref.time,
      key = _ref.key;
  return React.createElement('time', {
    key: key
  }, time);
}

function Title(_ref2) {
  var title = _ref2.title,
      key = _ref2.key;
  return React.createElement('h3', {
    key: key
  }, [title]);
}

function Channel(_ref3) {
  var channel = _ref3.channel,
      key = _ref3.key;
  return React.createElement('div', {
    className: 'channel',
    key: key
  }, channel);
}

function Body(_ref4) {
  var body = _ref4.body,
      key = _ref4.key;
  return React.createElement('p', {
    key: key
  }, body);
}

function PushNotification(_ref5) {
  var channels = _ref5.channels,
      payload = _ref5.payload,
      submission = _ref5.submission;
  var channel = channels ? channels[0] : 'None';
  var title = payload.title,
      body = payload.body;
  var key = 0;
  var time = formatSubmission(submission);
  return React.createElement('div', {
    className: 'pushNotificationItem',
    key: key++
  }, [Channel({
    channel: channel,
    key: key++
  }), Submission({
    time: time,
    key: key++
  }), Title({
    title: title,
    key: key++
  }), Body({
    body: body,
    key: key++
  })]);
}

export { PushNotification, Submission, Title, Channel, Body, formatSubmission };